import axiosInstance from '@/app/api/axiosInstance';
import { LoginCredentials, LoginResponse } from '@/app/types/auth';

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
    // Backend expects form data for login
    const formData = new URLSearchParams();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    const response = await axiosInstance.post<LoginResponse>('/auth/login', formData, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
    return response.data;
};
